'use client';
import { useEffect } from 'react';

export default function BodyClassSetter() {
  useEffect(() => {
    document.body.classList.add('customebgall');
    return () => {
      document.body.classList.remove('customebgall');
    };
  }, []);
  return null;
}
